<template>
  <BaseModal id="manage-resale-tax-modal" :value="true" @input="$emit('close')">
    <div class="content mx-auto mt-10 flex flex-col">
      <h1 class="txt-lg font-bold mb-4   ">
        New Resale Tax
      </h1>
      <FileSelector
        v-model="showFileSelector"
        type="resale-tax"
        :uploadOnly="true"
        @fileUploaded="handleFileUploaded"
      />
      <div class="date-form mb-4">
        <div class="form-group mb-3">
          <label
            for="fromDate"
            class="block text-sm font-medium text-gray-700 mb-1"
            >Valid from date</label
          >
          <input
            type="date"
            id="fromDate"
            v-model="newResaleTax.fromDate"
            class="regular full bordered"
            :class="{ 'border-red-500': formErrors.fromDate }"
            @input="validateForm"
          />
          <span v-if="formErrors.fromDate" class="text-red-500 text-xs">
            {{ formErrors.fromDate }}
          </span>
        </div>

        <div class="form-group mb-3">
          <label
            for="toDate"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ $t("message.manage_resale_tax.to_date") }}</label
          >
          <input
            type="date"
            id="toDate"
            v-model="newResaleTax.toDate"
            class="regular full bordered"
            :class="{ 'border-red-500': formErrors.toDate }"
            @input="validateForm"
          />
          <span v-if="formErrors.toDate" class="text-red-500 text-xs">
            {{ formErrors.toDate }}
          </span>
        </div>
      </div>
      <button
        @click="showFileSelector = true"
        class="btn-info-button w-28"
        v-if="newResaleTax.url == ''"
      >
        Upload File
      </button>
      <div v-else>
        <h2>
          File: {{ newResaleTax.fileName }} (<button @click="removeFile">
            delete</button
          >)
        </h2>
      </div>

      <button class="btn-success-button w-20 my-10" @click="submit">
        Submit
      </button>
      <hr class="mb-10" />
      <div v-if="resaleTaxList?.length > 0" class="flex flex-col gap-2">
        <h3>User resale tax list</h3>
        <div>
          <table class="table default-table" v-if="resaleTaxList">
            <thead>
              <th>
                From date
              </th>
              <th>
                To date
              </th>
              <th>
                Uploaded by user
              </th>
              <th>
                Validated by
              </th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in resaleTaxList"
                :key="item.id"
                class="hover"
                :class="{
                  'bg-green-100': isValidDate(
                    item.fromDate,
                    item.toDate,
                    item.deletedAt
                  ),
                  'bg-red-100': !isValidDate(
                    item.fromDate,
                    item.toDate,
                    item.deletedAt
                  )
                }"
              >
                <td>
                  {{ item.fromDate | dateWithHours }}
                </td>
                <td>
                  {{ item.toDate | dateWithHours }}
                </td>
                <td>
                  {{ item.uploaderName }}
                </td>
                <td>
                  {{ item.validatedBy ? item.validatedBy : "Not validated" }}
                </td>
                <td class="flex flex-row gap-2">
                  <a :href="item.url" target="_blank">
                    <img
                      class="icon w-8 h-8"
                      src="@/assets/icons/download.svg"
                      alt="Download"
                    />
                  </a>
                  <button v-if="currentUser.role == 'superadmin'">
                    <img
                      @click="deleteResaleTax(item.id)"
                      class="base-icon"
                      src="@/assets/icons/trash.svg"
                      alt="Delete"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else>
        No Resale tax in customer
      </div>
    </div>
  </BaseModal>
</template>
<script>
import FileSelector from "@/components/FileSelector.vue";
import {
  getCustomerResaleTax,
  createResaleTax as createResaleTaxApi,
  deleteResaleTax as deleteResaleTaxApi
} from "@/api/store/CustomersService.js";
export default {
  name: "ManageResaleTaxModal",
  props: {
    customerEmail: {
      type: [String, null],
      required: true
    },
    customerInfoautoId: {
      type: [String, null],
      required: true
    },
    customerName: {
      type: [String, null],
      required: true
    }
  },
  components: {
    FileSelector
  },
  data() {
    return {
      showFileSelector: false,
      resaleTaxList: null,
      newResaleTax: {
        fromDate: this.getFirstDayOfYear(),
        toDate: this.getLastDayOfYear(),
        fileName: "",
        url: "",
        s3Key: ""
      },
      formErrors: {
        fromDate: "",
        toDate: "",
        file: ""
      }
    };
  },
  mounted() {
    this.loadResaleTax();
  },
  computed: {
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    }
  },
  methods: {
    async loadResaleTax() {
      const resaleTaxList = await getCustomerResaleTax(
        this.customerEmail,
        this.customerInfoautoId
      );
      this.resaleTaxList = resaleTaxList;
    },
    handleFileUploaded(fileInfo) {
      this.newResaleTax.fileName = fileInfo.fileName;
      this.newResaleTax.url = fileInfo.url;
      this.newResaleTax.s3Key = fileInfo.s3Path;
    },
    async createResaleTax() {
      const resaleTaxData = {
        customer_email: this.customerEmail,
        infoauto_id: this.customerInfoautoId,
        from_date: this.newResaleTax.fromDate,
        to_date: this.newResaleTax.toDate,
        file_name: this.newResaleTax.fileName,
        url: this.newResaleTax.url,
        s3_key: this.newResaleTax.s3Key,
        customer_name: this.customerName
      };

      try {
        await createResaleTaxApi(resaleTaxData);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    validateForm() {
      this.formErrors = {
        fromDate: "",
        toDate: "",
        file: ""
      };

      let isValid = true;

      // Validar fromDate
      if (!this.newResaleTax.fromDate) {
        this.formErrors.fromDate = "La fecha inicial es requerida";
        isValid = false;
      }

      // Validar toDate
      if (!this.newResaleTax.toDate) {
        this.formErrors.toDate = "La fecha final es requerida";
        isValid = false;
      }

      // Validar que fromDate no sea mayor que toDate
      if (this.newResaleTax.fromDate && this.newResaleTax.toDate) {
        const fromDate = new Date(this.newResaleTax.fromDate);
        const toDate = new Date(this.newResaleTax.toDate);

        if (fromDate > toDate) {
          this.formErrors.toDate =
            "La fecha final no puede ser anterior a la fecha inicial";
          isValid = false;
        }
      }
      if (this.newResaleTax.url == "") {
        this.formErrors.file = "El archivo es requerido";
        isValid = false;
      }
      if (this.newResaleTax.fileName == "") {
        this.formErrors.file = "El archivo es requerido";
        isValid = false;
      }
      return isValid;
    },
    getFirstDayOfYear() {
      const currentYear = new Date().getFullYear();
      return `${currentYear}-01-01`;
    },
    getLastDayOfYear() {
      const currentYear = new Date().getFullYear();
      return `${currentYear}-12-31`;
    },
    resetDatesToDefaultYear() {
      this.newResaleTax.fromDate = this.getFirstDayOfYear();
      this.newResaleTax.toDate = this.getLastDayOfYear();
    },
    removeFile() {
      this.newResaleTax.fileName = "";
      this.newResaleTax.url = "";
      this.newResaleTax.s3Key = "";
    },
    async submit() {
      if (!this.validateForm()) {
        this.$toast.error("Incomplete form", {
          position: "top-right"
        });
        return;
      }
      if (await this.createResaleTax()) {
        console.log("Resale tax created");
        this.resetDatesToDefaultYear();
        this.showFileSelector = false;
        this.$emit("resaleTaxCreated");
        this.$toast.success("Resale tax created successfully");
      } else {
        console.log("Error creating resale tax");
        this.$toast.error("Error creating resale tax");
      }
    },
    isValidDate(fromDate, toDate, deletedAt) {
      if (deletedAt) {
        return false;
      }
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);
      const today = new Date();
      return fromDateObj <= today && toDateObj >= today;
    },
    deleteResaleTax(id) {
      if (confirm("Are you sure you want to delete this resale tax?")) {
        deleteResaleTaxApi(id)
          .then(() => {
            this.$toast.open({
              message: "Resale tax deleted",
              type: "success",
              position: "top-right"
            });
            this.loadResaleTax();
          })
          .catch(() => {
            this.$toast.open({
              message: "Error deleting resale tax",
              type: "error",
              position: "top-right"
            });
          });
      }
    }
  }
};
</script>
<style lang="postcss">
#manage-resale-tax-modal .modal-content {
  max-width: 700px;
  max-height: 700px;
}
#file-selector .modal-content {
  max-width: 600px;
  max-height: 600px;
}
</style>
